import React from "react";
import PropTypes from "prop-types";
import * as styles from "./BVRatingStar.css";
import { cx } from "emotion";

export class BVRatingStar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            onClick,
            onHover,
            index,
            activeStarsCount
        } = this.props;
        let activeColor;

        switch (activeStarsCount) {
        case 1:
            activeColor = styles.activeColor1;
            break;
        case 2:
            activeColor = styles.activeColor2;
            break;
        case 3:
            activeColor = styles.activeColor3;
            break;
        case 4:
            activeColor = styles.activeColor4;
            break;
        case 5:
            activeColor = styles.activeColor5;
            break;
        default:
            break;
        }

        return (
            <div
                onClick={() => onClick()}
                onMouseEnter={() => onHover(index)}
                onMouseLeave={() => onHover(null)}
                className={cx(
                    styles.starContainer,
                    index === 1 ? styles.firstStarContainer : {},
                    index === 5 ? styles.lastStarContainer : {},
                    index <= activeStarsCount ? activeColor : {}
                )}
            >
                <span>★</span>
            </div>
        );
    }
}

BVRatingStar.propTypes = {
    onHover: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    activeStarsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};